export const listCopyEnUs = {
    published: "Published",
    draft: "Draft",
    name: "Name",
    role: "Role",
    organisation: "Organization",
    email: "Email",
    dateOfBirth: "Date of Birth",
    labels: "Labels",
    status: "Status",
    actions: "Actions",
};
